// src/pages/outsourcing_management/InquiryAuditTrail.tsx
//
// The inquiry's append-only workflow history (INQUIRY_AUDIT). Until it
// existed, an inquiry's only trail was the generic row-diff capture in
// EVENTLOGS - which records which columns changed rather than what anyone
// did, and which nothing exposes over the API. It could not answer "who
// rejected this, and why", which is the question the panel is here for.
//
// Rendering is shared with the requisition trail (components/Dashboard/
// AuditTrail); this file is the action codes and the status labels.
import { FunctionComponent } from "react";
import AuditTrail from "components/Dashboard/AuditTrail";
import { InquiryAuditEntryType } from "types/InquiryTypes";
import { inquiryStatusLabel } from "./constants/inquiryStatusColors";

type PropsType = {
  auditTrail: InquiryAuditEntryType[];
};

const ACTION_DOT_COLOR: Record<string, string> = {
  CREATE: "#868686",
  // A send is the one action that reaches outside the company.
  SEND: "#007474",
  SEND_PURCHASE_ORDER: "#007474",
  STATUS_CHANGE: "#008b80",
  // A note about something that happened off the flow - deliberately quiet.
  OTHER: "#868686",
  // Goods-in counts: routine, one per change, so as quiet as a note.
  DELIVERY_UPDATE: "#868686",
  REJECT: "#e12c4f",
};

const ACTION_LABELS: Record<string, string> = {
  // Would otherwise title-case to "Status Change", which reads like a noun
  // for something that is already described by the from -> to line under it.
  STATUS_CHANGE: "Moved",
  SEND_PURCHASE_ORDER: "Purchase order sent",
  OTHER: "Note",
  DELIVERY_UPDATE: "Goods in",
};

const InquiryAuditTrail: FunctionComponent<PropsType> = ({ auditTrail }) => (
  <AuditTrail
    entries={auditTrail}
    dotColors={ACTION_DOT_COLOR}
    actionLabels={ACTION_LABELS}
    statusLabel={inquiryStatusLabel}
    emptyText="Nothing has happened to this inquiry yet."
  />
);

export default InquiryAuditTrail;
